import Vue from "vue";
import App from "./App.vue";
import router from "./route";
import store from "./store";
import 'vue-material-design-icons/styles.css';
import vuetify from './plugins/vuetify';
import axios from 'axios'
import VueAxios from 'vue-axios'

Vue.config.productionTip = false;
Vue.use(VueAxios, axios);

export const eventBus = new Vue();

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");
